<ng-container *ngIf="active && message">

  <a *ngIf="link; else noLink"
     [routerLink]="link"
     class="banner"
     [ngClass]="'banner-' + type"
     matRipple
     [matRippleDisabled]="!isClickable">

    <span class="message">{{ message | translate }}</span>
  </a>

  <ng-template #noLink>
    <div (click)="handleClick()"
         class="banner"
         [ngClass]="'banner-' + type"
         matRipple
         [matRippleDisabled]="!isClickable">

      <span class="message">{{ message | translate }}</span>
    </div>
  </ng-template>

</ng-container>
